<template>
  <layout-modal
    :classes="classes" 
    visible
    @close="close">

    <!-- loading -->
    <template v-if="loading">
      <div class="layout-modal__loader">
        <ui-loader />
      </div>
    </template>

    <!-- Data -->
    <template v-else>
      <div class="view-catalog-product__body">

        <!-- Illustration -->
        <div
          v-if="hasFigure" 
          class="view-catalog-product__figure">
          <img 
            class="view-catalog-product__image" 
            :src="figure"
            :alt="product.name" />
        </div>

        <div class="view-catalog-product__content">
          <h2 class="view-catalog-product__title">{{ product.name }}</h2>
          <p 
            v-if="product.description" 
            class="view-catalog-product__description">{{ product.description }}</p>

          <!-- Options -->
          <div
            v-if="hasOptions" 
            class="view-catalog-product__options">
            <product-option 
              v-for="option in options" 
              :key="option.id" 
              :option="option"
              @selection-change="(values) => { onChangeSelection(values, option) }"
            />
          </div>
        </div>
      </div>

    </template>
    
    <!-- Footer bar -->
    <template v-slot:footer class="view-catalog-product__footer">
      <forms-qty 
        v-if="item"
        :min="1"
        v-model="item.quantity"
      />

      <button 
        :disabled="!valid" 
        class="view-catalog-product__add"
        @click="onAddToCart">
        <span>Add for</span>
        <span :class="{ 'strike': hasPromoPrice }">{{ price }}</span>
        <span v-if="hasPromoPrice"> - {{ promoPrice }}</span>
      </button>
    </template>
  </layout-modal>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import FormsQty from '@/components/forms/qty'
import LayoutModal from '@/components/layouts/modal'
import ProductOption from '@/modules/catalog/components/product/option'

import MixinPrice from '@/modules/catalog/mixins/price';

import { CartItem } from '@sayl/oat-core'

export default {
  name: 'ProductView',
  
  components: {
    FormsQty,
    LayoutModal,
    ProductOption
  },

  mixins: [
    MixinPrice
  ],

  data() {
    return { 
      item: null,
      loading: true,
    }
  },

  computed: {
    ...mapState({
      cart: state => state['sayl-oat'].cart,
      product: state => state['sayl-oat.product'].product,
      options: state => state['sayl-oat.product'].product.options
    }),

    classes(){
      return {
        'view-catalog-product': true
      }
    },

    hasFigure(){
      return this.figure != null
    },

    figure(){
      return this.product &&
             this.product.figures && 
             this.product.figures.length 
             ? this.product.figures[0] : null;
    },

    hasOptions(){
      return this.options && this.options.length
    },

    hasPromoPrice() {
      return this.item && this.item.total.promo.value !== null;
    },

    price(){
      let v = this.item ? this.item.total.price.value : 0;
      return this.toCurrency({value: v });
    },

    promoPrice() {
      let v = this.item ? this.item.total.promo.value : 0;
      return this.toCurrency({value: v });
    },

    variant(){
      return this.product.variants[0]
    },

    valid() {
      return this.item && this.item.validate();
    }
  },

  methods: {
    ...mapActions({
      view: 'sayl-oat.product/view',
      addToCart: 'addToCart'
    }),

    ...mapMutations({
      setProduct: 'sayl-oat.product/setProduct'
    }),

    close(){
      this.$router.push({ name:'sayl-oat-catalog.catalog' });
    },

    onAddToCart() {
      this.addToCart(this.item);
      this.close();
    },

    onChangeSelection(value, option) {
      const opt = this.item.options.find(o => o.id === option.id);
      if(value.selection instanceof Object){
        opt.selection = {...value.selection}
      } else {
        opt.selection = value.selection;
      }
    } 
  },

  mounted() {
    this.view(this.$route.params.product).then((result) => {
      this.item = CartItem.create({
        product: this.product, 
        options: this.options, 
        quantity: 1
      }); 

      this.loading = false;
    }).catch(error => {
      console.error(error);
    });
  },

  beforeDestroy() {
    this.setProduct(null);
  }
}
</script>
